<div class="page-wrapper">
  <div class="blob blob-main"></div>
  <div class="blob blob-small"></div>
  <div class="blob blob-accent"></div>

  <div class="page-container">

    <!-- Header -->
    <header class="top-nav">
      <div class="hero-logo">
        <img
          src="../../assets/images/Logo.svg"
          alt="Nishwik Logo"
          class="img-fluid"
        />
      </div>
      <span class="nav-tag">Society OS</span>
    </header>

    <main class="main-content">
      <div class="split-layout">

        <!-- Left: Brand panel -->
        <div class="brand-panel">
          <div class="brand-icon-wrap">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="28" height="28">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </div>

          <h1 class="brand-heading">
            Secure Access<br />
            <span class="accent">Reset Required</span>
          </h1>

          <p class="brand-desc">
            Your password has expired as part of our society security policy.
            Please set a new password to regain full access to your society dashboard.
          </p>

          <div class="security-badges">
            <div class="sec-badge">
              <div class="sec-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                  <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </div>
              <span>256-bit Encrypted</span>
            </div>
            <div class="sec-badge">
              <div class="sec-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <span>Secure by Default</span>
            </div>
            <div class="sec-badge">
              <div class="sec-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <span>Password Policy Compliant</span>
            </div>
          </div>
        </div>

        <!-- Right: Reset Form -->
        <div class="form-side">
          <div class="reset-card">
            <div class="card-top-bar"></div>
            <div class="card-inner">
              <div class="card-eyebrow">Password Reset</div>
              <h2 class="card-title">Set New Password</h2>
              <p class="card-subtitle">Choose a strong password to protect your society account.</p>

              <form #resetForm="ngForm" (ngSubmit)="updatePassword()">

                <!-- New Password -->
                <div class="field">
                  <label for="newPassword">New Password <span class="req">*</span></label>
                  <div class="input-wrap">
                    <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                      <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                    </svg>
                    <input
                      type="password"
                      id="newPassword"
                      name="newPassword"
                      [(ngModel)]="newPassword"
                      #newPass="ngModel"
                      placeholder="Min. 6 characters"
                      required
                      minlength="6"
                      [class.error]="newPass.invalid && newPass.touched"
                    />
                  </div>
                  <span class="field-error" *ngIf="newPass.invalid && newPass.touched">
                    <span *ngIf="newPass.errors?.['required']">New password is required.</span>
                    <span *ngIf="newPass.errors?.['minlength']">Password must be at least 6 characters.</span>
                  </span>
                </div>

                <!-- Confirm Password -->
                <div class="field">
                  <label for="confirmPassword">Confirm Password <span class="req">*</span></label>
                  <div class="input-wrap">
                    <svg class="field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                    <input
                      type="password"
                      id="confirmPassword"
                      name="confirmPassword"
                      [(ngModel)]="confirmPassword"
                      #confirmPass="ngModel"
                      placeholder="Re-enter new password"
                      required
                      [class.error]="confirmPass.touched && confirmPassword !== newPassword"
                    />
                  </div>
                  <span class="field-error" *ngIf="confirmPass.touched && confirmPass.errors?.['required']">
                    Confirm password is required.
                  </span>
                  <span class="field-error" *ngIf="confirmPass.touched && !confirmPass.errors?.['required'] && confirmPassword !== newPassword">
                    Passwords do not match.
                  </span>
                </div>

                <!-- Password Strength -->
                <div class="password-hint" *ngIf="newPassword">
                  <div class="hint-bar">
                    <div
                      class="hint-fill"
                      [style.width]="newPassword.length >= 10 ? '100%' : newPassword.length >= 6 ? '60%' : '25%'"
                      [class.weak]="newPassword.length < 6"
                      [class.fair]="newPassword.length >= 6 && newPassword.length < 10"
                      [class.strong]="newPassword.length >= 10"
                    ></div>
                  </div>
                  <span
                    class="hint-label"
                    [class.weak]="newPassword.length < 6"
                    [class.fair]="newPassword.length >= 6 && newPassword.length < 10"
                    [class.strong]="newPassword.length >= 10"
                  >
                    {{ newPassword.length < 6 ? 'Weak' : newPassword.length < 10 ? 'Fair' : 'Strong' }}
                  </span>
                </div>

                <button
                  type="submit"
                  class="btn-submit"
                  [disabled]="!newPassword || !confirmPassword || newPassword !== confirmPassword || newPass.invalid"
                >
                  Update Password
                </button>
              </form>

              <div class="card-footer-links">
                <a routerLink="/login" class="back-link">← Back to Login</a>
                <a (click)="redirectToSignUp()" class="signup-link" style="cursor:pointer;">
                  New here? <strong>Create account</strong>
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </main>

  </div>

  <footer class="bottom-bar">
    <div class="foot-inner">
      <span class="copyright">© 2026 Nishwik Society OS. All rights reserved.</span>
      <div class="foot-links">
        <a routerLink="/policy/privacy">Privacy Policy</a>
        <a routerLink="/policy/terms">Terms &amp; Conditions</a>
        <a routerLink="/policy/contact">Contact us</a>
      </div>
    </div>
  </footer>
</div>